import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { Upload, Button } from 'antd'
import { EasyIcon, ListPropsContext, postMsg } from 'src/components'
import { appStore, listStore } from 'src/stores'
import { getApiURL } from 'src/utils/axios'

type Props = {
  config: ButtonConfig
}
const CustomImport = (props: Props) => {
  const table = listStore.table.get(useContext(ListPropsContext).formCode)

  const uploadProps = useMemo(() => {
    return {
      name: 'file',
      showUploadList: false,
      action: getApiURL(props.config.API_URL),
      data: { OrgId: appStore.current.headers.OrgId },
      headers: appStore.current.headers,
      onChange: (info: any) => {
        const { name, status, response = {} } = info.file
        const { IsSuccessful, ErrorMessage } = response
        if (status === 'done') {
          if (IsSuccessful) {
            postMsg(`${name} 已导入`)
            table?.reload()
          } else {
            postMsg(`${name} 导入失败，${ErrorMessage}`, 'error')
          }
        } else if (status === 'error') {
          if (response.ErrorMessage) {
            postMsg(`${name} 导入错误，${ErrorMessage}`, 'error')
          } else {
            postMsg(`${name} 导入错误`, 'error')
          }
        }
      }
    }
  }, [])

  const { LABEL, ICON } = props.config
  return (
    <Upload {...uploadProps}>
      <Button type='primary' icon={<EasyIcon type={ICON} defaultIcon='UploadOutlined' />}>{LABEL}</Button>
    </Upload>
  )
}

export default CustomImport